module.exports = __webpack_public_path__ + "static/media/minus_black.ce096a49.svg";